/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable array-callback-return */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NavbarHome from './nav-bar-home';
import NavbarCommon from './nav-bar-common';
import './index.css';

const iconsMundigea = {
  paquetes: '/tpl/images/icons/mundigea-icons-paquetes.svg',
  'vuelo-mas-hotel': '/tpl/images/icons/mundigea-icons-vuelo+hotel.svg',
  hoteles: '/tpl/images/icons/mundigea-icons-hoteles.svg',
  vuelos: '/tpl/images/icons/mundigea-icons-vuelos.svg',
  cruceros: '/tpl/images/icons/mundigea-icons-cruceros.svg',
  seguros: '/tpl/images/icons/mundigea-icons-seguros.svg',
  exoticos: 'soap soap-icon-beach',
  'destinos-exoticos': 'soap soap-icon-beach',
  'salidas-grupales': '/tpl/images/icons/mundigea-icons-grupales.svg',
  ofertas: 'fa fa-tag',
  cybermonday: 'fa fa-tag',
};
class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowsSize: 0,
      botonesVisibles: [],
      solapasOcultas: [],
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }

  componentDidMount() {
    this.setState({ windowsSize: window.innerWidth });
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  setNavBarButtonsInMenu = (solapas) => {
    const anchoBoton = 136;
    const tolerancia = 130;
    const anchoBotonMenu = (document.getElementById('dropdownMenu1') && parseFloat(getComputedStyle(document.getElementById('dropdownMenu1'), null).width.replace('px', ''))) || 0;
    const elementContenedorWidth = (document.getElementsByClassName('secciones-box')[0] && parseFloat(getComputedStyle(document.getElementsByClassName('secciones-box')[0], null).width.replace('px', ''))) || 0;
    const anchoContenedor = (elementContenedorWidth) - anchoBotonMenu - tolerancia;
    const cantMaximaDeBotones = Math.floor((anchoContenedor / anchoBoton));
    const activarMenu = (solapas !== undefined ? solapas.length : 0) > cantMaximaDeBotones;

    const mostrar = [];
    const ocultar = [];

    if (activarMenu) {
      solapas.map((solapa, index) => {
        if (index <= cantMaximaDeBotones) {
          mostrar.push(solapa);
        } else {
          ocultar.push(solapa);
        }
      });

      return { visibles: mostrar, ocultas: ocultar };
    }
    return { visibles: solapas, ocultas: [] };
  }

  updateDimensions() {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      width: window.innerWidth,
    });
  }

  armarSolapasFijas(datosUsuario) {
    const solapasFijas = [];
    if (datosUsuario.seccionOpenVoucher) {
      solapasFijas.push({
        titulo: 'Open Voucher',
        modulo: 'open-voucher',
        icono: 'fa fa-ticket',
        url: '/buscarxpaquetes/open-voucher',
        activo: (window.location.pathname.includes('/buscarxpaquetes/open-voucher')),
      });
    }
    if (this.props.header.idAgencia) {
      solapasFijas.push({
        titulo: 'Paquetes',
        modulo: 'paquetes',
        icono: 'fa fa-suitcase',
        url: '/paquetes',
        activo: (!window.location.pathname.includes('/buscarxpaquetes/open-voucher')),
      });
    }
    if (window.location.href.includes('mundigea') && this.props.header.idAgencia === 1) {
      solapasFijas.push({
        titulo: 'Vuelo + Hotel',
        modulo: 'vuelo-mas-hotel',
        icono: 'fa fa-suitcase',
      });
    }
    if (datosUsuario.seccionHoteles === 'SI') {
      solapasFijas.push({
        titulo: 'Hoteles',
        modulo: 'hoteles',
        icono: 'fa fa-bed',
      });
    }
    if (datosUsuario.seccionVuelos === 'SI') {
      const urlVuelos = (datosUsuario.seccionVuelosUrl === 'vuelos' ? '/vuelos' : `/?mode=marca_blanca&user_id=${datosUsuario.idAgencia}module=iframe_vuelos`);
      solapasFijas.push({
        titulo: 'Vuelos',
        modulo: 'vuelos',
        icono: 'fa fa-plane',
        url: urlVuelos,
      });
    }
    if (datosUsuario.seccionCruceros === 'SI') {
      solapasFijas.push({
        titulo: 'Cruceros',
        modulo: 'cruceros',
        icono: 'fa fa-ship',
      });
    }
    if (datosUsuario.seccionSeguros === 'SI') {
      solapasFijas.push({
        titulo: 'Seguros',
        modulo: 'seguros',
        icono: 'fa fa-medkit',
      });
    }

    if (datosUsuario.seccionSalidasGrupales === 'SI') {
      solapasFijas.push({
        titulo: 'Grupales',
        modulo: 'salidas-grupales',
        icono: 'fa fa-group',
      });
    }

    if (datosUsuario.seccionExoticos === 'SI') {
      solapasFijas.push({
        titulo: 'Exóticos',
        modulo: 'destinos-exoticos',
        icono: 'soap soap-icon-beach',
      });
    }

    if (datosUsuario.seccionOfertas === 'SI') {
      solapasFijas.push({
        titulo: 'Ofertas',
        modulo: 'ofertas',
        icono: 'fa fa-tag',
      });
    }
    if (datosUsuario.seccionCybermonday === 'SI') {
      solapasFijas.push({
        titulo: 'Cyber Monday',
        modulo: 'cybermonday',
        icono: 'fa fa-tag',
        destacado: true,
      });
    }
    if (datosUsuario.seccionHotsale === 'SI') {
      solapasFijas.push({
        titulo: 'Hotsale',
        modulo: 'hotsale',
        icono: 'fa fa-tag',
        destacado: true,
      });
    }
    if (datosUsuario.seccionTravelsale === 'SI') {
      solapasFijas.push({
        titulo: 'Travelsale',
        modulo: 'travelsale',
        icono: 'fa fa-tag',
        destacado: true,
      });
    }
    return solapasFijas;
  }

  armarSolapas() {
    const dominio = window.location.hostname;
    const datosUsuario = this.props.header;
    const datosSolapasFijas = this.armarSolapasFijas(datosUsuario);
    let solapasDeAplicacionFijas = [];
    let solapasDeAplicacion = [];
    const mode = datosUsuario.idAgencia !== 1
      ? `?mode=marca_blanca&user_id=${this.props.header.idAgencia}` : '';

    solapasDeAplicacionFijas = datosSolapasFijas.map((solapa, index) => {
      const modulo = () => {
        switch (solapa.modulo) {
          case 'open-voucher':
            return solapa.url;
          case 'vuelos':
            return solapa.url;
          case 'paquetes':
            return solapa.url;
          case 'hoteles':
            return `/${solapa.modulo}`;
          case 'cruceros':
            return `/${solapa.modulo}`;
          case 'seguros':
            return `/${solapa.modulo}`;
          case 'grupales':
            return `/${solapa.modulo}`;
          case 'travelsale':
            return `/${solapa.modulo}`;
          case 'vuelo-mas-hotel':
            return `/${solapa.modulo}`;
          case 'hotsale':
            return this.props.header.idAgencia !== 1 ? '/hotsale' : '/hot-sale';
          case 'destinos-exoticos':
            return `/${solapa.modulo}`;
          case 'cybermonday':
            return `/${solapa.modulo}`;
          default:
            return `/?${mode}&module=${solapa.modulo}`;
        }
      };

      function solapaIconFactory(solapa, id) {
        if (iconsMundigea[solapa.modulo] && iconsMundigea[solapa.modulo].includes('/') && id === 1) {
          return <img alt='ico' src={`https://mundigea.com.ar${iconsMundigea[solapa.modulo]}`} className='svg-icon' />;
        }
        return <i className={solapa.icono} aria-hidden='true' />;
      }

      const urlModule = `https://${dominio}${modulo()}`;
      const icono = solapaIconFactory(solapa, this.props.header.idAgencia);
      const solapaClass = solapa.activo ? 'btn-box active' : 'btn-box';

      return (
        <div key={solapa.titulo} className='nav-item text-center'>
          <a href={urlModule} className={solapaClass}>
            <div className='item-icon'>{icono}</div>
            <div className='item-label'>{solapa.titulo}</div>
          </a>
        </div>
      );
    });
    /* eslint-disable */
    solapasDeAplicacion = this.props.tabs.map((tab) => {
      const module = tab.titulo.replace(' ', '_');
      try {
        return (
          <div key={tab.id} className='nav-item text-center'>
            <a href={`https://${window.location.hostname}/?mode=marca_blanca&user_id=${tab.userId}&module=iframe_${module}&iframe_id=${tab.id}`} className='btn-box'>
              <div className='item-icon'><i className={tab.icon.icon} aria-hidden='true' /></div>
              <div className='item-label'>{tab.titulo}</div>
            </a>
          </div>
        );
      } catch (e) {
        /* eslint-disable no-console */
        console.warn(`No se puedo cargar la solapaId: ${tab.id}`);
        console.warn(e);
        /* eslint-enable no-console */
      }
    });
    /* eslint-enable */

    return solapasDeAplicacionFijas.concat(solapasDeAplicacion);
  }

  /* eslint-disable react/destructuring-assignment */

  render() {
    if (typeof window === 'undefined') return null; // postpone render until browser

    const solapas = this.armarSolapas();
    let mobile = true;
    let solapasOrganizadas = { visibles: [], ocultas: [] };

    if (solapas !== undefined && this.state.windowsSize > 768) {
      solapasOrganizadas = this.setNavBarButtonsInMenu(solapas);
      mobile = false;
    }

    const template = this.props.template !== undefined
      ? this.props.template
      : '';

    switch (template) {
      case 'home':
        return <NavbarHome mobile={mobile} solapas={solapas} solapasOrganizadas={solapasOrganizadas} />;
      default:
        return <NavbarCommon solapas={solapas} />;
    }
  }
}

const mapStateToProps = function (store) {
  return {
    header: store.applicationState.header,
    tabs: store.applicationState.navBar,
  };
};

Tabs.propTypes = {
  header: PropTypes.object,
};

export default connect(mapStateToProps, null)(Tabs);
